import type { PlainKey } from "../../i18n/types";
/**
 * Shared, pure pieces of the bouquet builders (shop-floor tablet and the phone
 * builder for managers/owners). UI stays per-surface; only formatting and the
 * category rules live here so the two builders can't drift apart.
 */

/**
 * The only categories a bouquet builder offers, in display order. Flowers are
 * "+1 unit" item cards; ribbon/paper are cut by cm from rolls. Anything else
 * in the catalog (toys, candles, vases…) is not a bouquet component.
 */
export const BUILDER_TABS = ["FLOWER", "RIBBON", "PAPER"];

export type ConsumablePresetValue = "SMALL" | "MEDIUM" | "BIG";

export const PAPER_PRESETS: ReadonlyArray<{
  value: ConsumablePresetValue;
  /** The message key. See `NoteFont.labelKey` for why this is not words. */
  labelKey: PlainKey;
  cm: number;
}> = [
  { value: "SMALL", labelKey: "builder.presetSmall", cm: 25 },
  { value: "MEDIUM", labelKey: "builder.presetMedium", cm: 50 },
  { value: "BIG", labelKey: "builder.presetBig", cm: 85 },
];

/**
 * S5: NOT a second implementation — the same `money` the whole app uses, under
 * the name this corner already calls it. It was `€${n.toFixed(2)}`: symbol
 * first, dot decimal, no locale, which is half of why a Russian screen showed
 * `305.00 €` beside `€10.00`.
 */
export { money as eur } from "../../i18n/intl";
